import React from 'react';
import PropTypes from 'prop-types';
import SelectNestedMenuDialog from './common/SelectNestedMenuDialog';
import { corporationStatisticsChangeNestedMenu } from '../../../../constants/SidebarValues';

const SelectCorporationStatisticsChangeDialog = (props) => (
  <SelectNestedMenuDialog
    {...props}
    title="企業統計情報の動向"
    nestedMenu={corporationStatisticsChangeNestedMenu}
    colCount={2}
  />
);

SelectCorporationStatisticsChangeDialog.propTypes = {
  toggleDialog: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  set: PropTypes.object,
  save: PropTypes.func.isRequired,
};

export default SelectCorporationStatisticsChangeDialog;



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/SelectNestedMenuDialog/SelectCorporationStatisticsChangeDialog.jsx